import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3b1b08c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-group" }
const _hoisted_5 = { class: "option-label" }
const _hoisted_6 = { class: "option-row" }
const _hoisted_7 = { class: "option-row" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "option-row" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "option-row" }
const _hoisted_12 = { class: "form-label" }
const _hoisted_13 = { class: "option-row" }
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = { class: "option-group" }
const _hoisted_16 = { class: "option-label" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BasicSubSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { ProxyMethod, ProxyMethodShow, getProxyShowValue, getProxyConfig } from './basic-options.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'basic-options',
  props: {
  modelValue: {
    type: Object as PropType<BasicSubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

/** 代理类型（用于UI展示） */
function getProxyMethodShow() {
  return getProxyShowValue(strategy.value.proxy.method, strategy.value.proxy.mode)
}

function handleChange() {
  emits('change')
}

function handleProxyTypeChange(val: ProxyMethodShow) {
  const config = getProxyConfig(val)
  strategy.value.proxy.method = config.method
  strategy.value.proxy.mode = config.mode
  handleChange()
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsTitle')), 1),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "option-row",
            modelValue: strategy.value.cloud_security,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.cloud_security) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsCloudPlan')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyType')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_radio_group, {
          "model-value": getProxyMethodShow(),
          disabled: __props.readonly,
          onChange: handleProxyTypeChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: _unref(ProxyMethodShow).ie
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyIe')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              label: _unref(ProxyMethodShow).http
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyHttp')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              label: _unref(ProxyMethodShow).socks5
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxySocks5')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              label: _unref(ProxyMethodShow).none
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyNone')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model-value", "disabled"])
      ]),
      (strategy.value.proxy.method === _unref(ProxyMethod).custom)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsServerAddress')), 1),
              _createVNode(_component_el_input, {
                modelValue: strategy.value.proxy.host,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.proxy.host) = $event)),
                placeholder: _unref(t)('groupPolicySettings.basicOptionsServerAddressPh'),
                disabled: __props.readonly,
                size: "small",
                style: {"width":"300px"},
                onChange: handleChange
              }, null, 8, ["modelValue", "placeholder", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyPort')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: strategy.value.proxy.port,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.proxy.port) = $event)),
                min: 1,
                max: 65535,
                disabled: __props.readonly,
                size: "small",
                "controls-position": "right",
                onChange: handleChange
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createVNode(_component_el_checkbox, {
              class: "option-row",
              modelValue: strategy.value.proxy.require_auth,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.value.proxy.require_auth) = $event)),
              modelModifiers: { number: true },
              "true-label": 1,
              "false-label": 0,
              disabled: __props.readonly,
              onChange: handleChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsProxyRequireAuth')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            (strategy.value.proxy.require_auth === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsUsername')), 1),
                    _createVNode(_component_el_input, {
                      modelValue: strategy.value.proxy.user,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.value.proxy.user) = $event)),
                      placeholder: _unref(t)('groupPolicySettings.basicOptionsUsernamePh'),
                      disabled: __props.readonly,
                      size: "small",
                      autocomplete: "off",
                      style: {"width":"300px"},
                      onChange: handleChange
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsPassword')), 1),
                    _createVNode(_component_el_input, {
                      modelValue: strategy.value.proxy.password,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.value.proxy.password) = $event)),
                      type: "password",
                      placeholder: _unref(t)('groupPolicySettings.basicOptionsPasswordPh'),
                      disabled: __props.readonly,
                      size: "small",
                      "show-password": "",
                      autocomplete: "new-password",
                      style: {"width":"300px"},
                      onChange: handleChange
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsDoNotDisturb')), 1),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.auto_interrupt,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((strategy.value.auto_interrupt) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsDoNotDisturbGame')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "option-row",
            modelValue: strategy.value.security_msg_center,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((strategy.value.security_msg_center) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsSecurityMsgCenter')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 1,
            class: "option-row",
            modelValue: strategy.value.pop_location,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((strategy.value.pop_location) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.basicOptionsPopLocation')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})